export const saveToken = (token) => {
    localStorage.setItem('authToken', token);
    document.cookie = `authToken=${token};path=/;`;
};
  
export const clearToken = () => {
  localStorage.removeItem('authToken');
  document.cookie = 'authToken=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
};
export const saveUserData = (token , email , id , name , type , role) => {
  localStorage.setItem('authToken', token);
  localStorage.setItem('email', email);
  localStorage.setItem('id', id);
  localStorage.setItem('user_name', name);
  localStorage.setItem('account_type', type);
  localStorage.setItem('crm_role', role);
  //document.cookie = `authToken=${token};path=/;`
}
export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('email');
  localStorage.removeItem('id');
  localStorage.removeItem('user_name');
  localStorage.removeItem('account_type');
  localStorage.removeItem('crm_role');
};
export const isLogged = () => !!localStorage.getItem("authToken");

export const getToken = () => localStorage.getItem("authToken");
  